import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, subtitle, dark = false, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {overline && (
      <Reveal>
        <p className={`text-xs uppercase tracking-[0.3em] font-semibold ${dark ? "text-gold" : "text-gold-dark"}`}>
          {overline}
        </p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className={`mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-balance ${dark ? "text-cream" : "text-ink"}`}>
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed ${dark ? "text-cream/60" : "text-[#525D6B]"}`}>{subtitle}</p>
      </Reveal>
    )}
  </div>
);

export const Marquee = ({ items, dark = true, bare = false }) => {
  const row = [...items, ...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-6 ${bare ? "" : `border-y ${dark ? "bg-ink border-white/10" : "bg-cream border-sand"}`}`}
    >
      <div className="flex w-max animate-marquee-slow">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className={`font-serif italic text-2xl sm:text-3xl px-8 ${dark ? "text-cream/70" : "text-ink/60"}`}>
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-gold shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export { EASE };
